import Svg from '../generated/Edit';
import { Icon, type IconProps } from './Icon';

export const EditIcon = (props: IconProps) => <Icon component={Svg} name="edit" {...props} />;
